// Tier (rütbe) sistemi — sezonluk ELO'ya göre otomatik rozet.
// Web ve mobil paylaşımlı mantık.

export type TierKey = 'bronze' | 'silver' | 'gold' | 'platinum' | 'diamond';

// NOT: name/nameEn alanları kaldırıldı — tier adı artık shared/src/i18n/{locale}.json
// içindeki `tiers.<key>` key'inden geliyor (N-dil desteği için). Kullanım:
// `(t.tiers as any)[tier.key]`.
export interface Tier {
  key: TierKey;
  icon: string;       // emoji rozeti
  color: string;      // ana renk
  bgColor: string;    // soft arka plan
  min: number;        // dahil
  max: number | null; // hariç (null = sonsuz)
}

export const TIERS: Tier[] = [
  { key: 'bronze',   icon: '🥉', color: '#A0522D', bgColor: 'rgba(160,82,45,0.12)',  min: 0,    max: 1100 },
  { key: 'silver',   icon: '🥈', color: '#9CA3AF', bgColor: 'rgba(156,163,175,0.18)', min: 1100, max: 1300 },
  { key: 'gold',     icon: '🥇', color: '#D4AF37', bgColor: 'rgba(212,175,55,0.18)',  min: 1300, max: 1500 },
  { key: 'platinum', icon: '💠', color: '#5EC8E0', bgColor: 'rgba(94,200,224,0.18)',  min: 1500, max: 1700 },
  { key: 'diamond',  icon: '💎', color: '#7C3AED', bgColor: 'rgba(124,58,237,0.18)',  min: 1700, max: null },
];

export function getTier(rating: number): Tier {
  for (const t of TIERS) {
    if (rating >= t.min && (t.max === null || rating < t.max)) return t;
  }
  return TIERS[0];
}

/** Bir sonraki tier'a kalan puan; en üst tier ise null. */
export function pointsToNextTier(rating: number): { nextTier: Tier; pointsLeft: number } | null {
  const current = getTier(rating);
  if (current.max === null) return null;
  const next = TIERS.find(t => t.min === current.max);
  if (!next) return null;
  return { nextTier: next, pointsLeft: current.max - rating };
}

/** Eski rating'den yeni rating'e geçişte tier değişti mi? +1 / -1 / 0 döner. */
export function tierDirection(oldRating: number, newRating: number): 1 | 0 | -1 {
  const oldIdx = TIERS.indexOf(getTier(oldRating));
  const newIdx = TIERS.indexOf(getTier(newRating));
  if (newIdx > oldIdx) return 1;
  if (newIdx < oldIdx) return -1;
  return 0;
}
